<template>
  <div
    class="text-center"
  >
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <validation-provider
          v-slot="{ errors }"
          name="id"
        >
          <v-btn
            :fab="!isImport"
            :small="!isImport"
            color="secondary"
            class="mb-2 ml-2"
            v-bind="attrs"
            v-on="on"
            @click="dialogUpload=!dialogUpload"
          >
            <template v-if="isImport">
              Import
            </template>
            <v-icon
              dark
            >
              {{ current_filter.icon }}
            </v-icon>
          </v-btn>
          <div
            v-if="filter != 'report'"
            class="v-messages error--text"
          >
            {{ errors[0] }}
          </div>
        </validation-provider>
      </template>
      <span>{{ current_filter.tooltip }}</span>
    </v-tooltip>
    <v-dialog
      v-model="dialogUpload"
      max-width="500px"
      :fullscreen="$vuetify.breakpoint.xs"
    >
      <v-card>
        <v-card-title>
          {{ current_filter.label }}
        </v-card-title>
        <v-card-text>
          <div v-if="currentFile[0]">
            <div>
              <v-progress-linear
                v-model="progress"
                color="light-blue"
                height="25"
                reactive
              >
                <strong>{{ progress }} %</strong>
              </v-progress-linear>
            </div>
          </div>
          <v-row
            v-if="false"
            no-gutters
            justify="center"
            align="center"
          >
            <v-col cols="8">
              <v-file-input
                :key="componentKey"
                show-size
                :label="this.$t('file_input')"
                truncate-length="15"
                :accept="current_filter.pattern"
                :multiple="current_filter.multiple"
                style="width: 250px"
                @change="selectFile"
              />
            </v-col>
            <v-col cols="4" class="pl-2">
              <v-btn
                color="success"
                dark
                class="mb-2"
                @click="upload"
              >
                {{ $t('upload') }}
                <v-icon
                  right
                  dark
                >
                  {{ current_filter.icon }}
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="true"
            no-gutters
            justify="center"
            align="center"
          >
            <drop-file
              :files="currentFile"
              :accept="current_filter.pattern"
              :multiple="current_filter.multiple"
            />
            <v-spacer />
            <v-btn
              :disabled="currentFile.length === 0"
              color="success"
              dark
              class="my-2"
              @click="upload"
            >
              {{ $t('upload') }}
              <v-icon
                right
                dark
              >
                {{ current_filter.icon }}
              </v-icon>
            </v-btn>
          </v-row>
          <v-alert
            v-if="message"
            border="left"
            color="blue-grey"
            dark
          >
            {{ message }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import UploadService from '../services/UploadFilesService'
  import DropFile from '@/components/DropFile.vue'

  export default {
    name: 'UploadFiles',
    components: { DropFile },
    props: {
      sourceType: {
        type: String,
        default: '',
      },
      filter: {
        type: String,
        default: 'report',
      },
      uploadParams: {
        type: Object,
        default: () => ({}),
      },
      isImport: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        dialogUpload: false,
        currentFile: [],
        progress: 0,
        message: '',
        componentKey: 0,
        filters: [
          {
            type: 'report',
            pattern: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
            label: this.$t('import_datas'),
            tooltip: this.$t('data_import'),
            multiple: false,
            icon: '$upload',
          },
          {
            type: 'document',
            pattern: '.jpg,.png,.bmp,.pdf',
            label: this.$t('upload_document'),
            tooltip: this.$t('document_upload'),
            multiple: true,
            icon: '$upload',
          },
          {
            type: 'avatar',
            pattern: 'image/*',
            label: this.$t('upload_image'),
            tooltip: this.$t('avatar_upload'),
            multiple: false,
            icon: '$upload_photo',
          },
        ],
      }
    },
    computed: {
      current_filter () { return this.filters.filter(s => s.type === this.filter)[0] },
    },
    watch: {
      dialogUpload (val) {
        val || this.closeDialog()
      },
    },
    mounted () {
      // console.log(this.filters.filter(s => s.type === 'avatar')[0].pattern)
      /* UploadService.getFiles().then((response) => {
        this.fileInfos = response.data
      }) */
    },
    methods: {
      selectFile (file) {
        this.progress = 0
        if (Array.isArray(file)) {
          this.currentFile = file
        } else {
          this.currentFile.push(file)
        }
      },
      upload () {
        if (!this.currentFile) {
          this.message = this.$t('please_select_a_file')
          return
        }

        // console.log(this.currentFile)
        this.message = ''

        UploadService.upload(
          this.currentFile,
          this.sourceType,
          this.uploadParams,
          (event) => { this.progress = Math.round((100 * event.loaded) / event.total) },
        )
          .then((response) => {
            this.message = response.data.message
            // console.log(response.data)
            // return UploadService.getFiles()
            this.$emit('success', response.data)
            this.closeDialog()
          })
          .catch(() => {
            this.progress = 0
            this.message = this.$t('could_not_upload_the_file')
            this.currentFile = []
          })
      },

      closeDialog () {
        this.currentFile = []
        this.progress = 0
        this.message = ''
        this.componentKey++
        this.dialogUpload = false
      },
    },
  }
</script>
